import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';
import type { PreviewProps } from '@xing-com/crate-lebenslauf-xinglets';

import {
  TemplateStyled,
  ScaleContainer,
  Scale,
  StyledButton,
} from './preview.styled';
import { useScale } from './use-scale';

export const Preview: React.FC<PreviewProps> = ({
  pageVisible,
  setTotalPages,
  className,
  onOpenPreview,
}) => {
  const { theme, cv, showAnschreibenBanner } = useReadVitaReactiveVariable();
  const element = React.useRef<HTMLDivElement>(null);
  const autoScale = useScale(element);

  if (!theme || !cv) {
    // TODO: How to handle the nullability of cv and theme?
    return <p>An error occured!</p>;
  }

  return (
    <ScaleContainer
      ref={element}
      className={className}
      $openPreview={!!onOpenPreview}
      $showAnschreibenBanner={!!showAnschreibenBanner}
    >
      <Scale $scale={autoScale} aria-hidden="true">
        <TemplateStyled
          pageVisible={pageVisible}
          setTotalPages={setTotalPages}
        />
      </Scale>
      {onOpenPreview && (
        // @ts-expect-error FIXME: SC6
        <StyledButton variant="primary" onClick={onOpenPreview} tabIndex="-1">
          <FormattedMessage id="CRATE_LEBENSLAUF_PREVIEW_BUTTON" />
        </StyledButton>
      )}
    </ScaleContainer>
  );
};
